import { ff } from '@atlassian/jira-feature-flagging-using-meta';

export const generateGetItemsByIdsQueryVariables = (sourceAri: string, ids: string[]) => ({
	sourceAri,
	ids,
	isRoadmapsCriticalDataItemFlaggedEnabled: ff('jsw.timeline.return-flagged-attribute-fe'),
});
